// Mock data for Fortunexis LLC website

export const COMPANY = {
  name: "Fortunexis LLC",
  tagline: "...accelerating your business growth",
  email: "hello@fortunexisfinance.com",
  phones: [
    { label: "Sales", number: "+971 54 321 6477" },
    { label: "Support", number: "+971 55 102 9595" },
  ],
  address:
    "307 HDS Business Center, Cluster M, JLT, Dubai, United Arab Emirates",
  offices: [
    {
      city: "Dubai (Head Office)",
      details:
        "307 HDS Business Center, Cluster M, JLT, Dubai, United Arab Emirates",
    },
    {
      city: "United States",
      details:
        "16192 Coastal Highway, Lewes, Delaware 19958-9776, USA",
    },
    {
      city: "Singapore",
      details: "Marina Bay Financial Centre, Singapore 018983",
    },
    {
      city: "London",
      details: "Fortunexis Ltd, 2 Frederick Street, London WC1X 0ND, United Kingdom",
    },
  ],
};

export const NAV = [
  { label: "Home", href: "/" },
  {
    label: "About Us",
    href: "/about",
    children: [
      { label: "Our Company", href: "/about" },
      { label: "Our Team", href: "/team" },
    ],
  },
  {
    label: "Debt",
    href: "/debt",
    children: [
      { label: "Loan Against Property", href: "/services/loan-against-property" },
      { label: "Loan Against Gold & Diamond", href: "/services/loan-against-gold-diamond" },
      { label: "Small Scale Financing", href: "/services/small-scale-financing" },
      { label: "Large Scale Financing", href: "/services/large-scale-financing" },
      { label: "Project Funding", href: "/services/project-finance" },
      { label: "Project Finance", href: "/services/project-finance" },
    ],
  },
  {
    label: "Equity",
    href: "/equity",
    children: [
      { label: "Private Equity", href: "/services/private-equity" },
      { label: "Venture Capital", href: "/services/venture-capital" },
    ],
  },
  {
    label: "Trade Finance",
    href: "/trade-finance",
    children: [
      { label: "Letter of Credit", href: "/services/letter-of-credit" },
      { label: "Standby Letter of Credit", href: "/services/sblc" },
      { label: "Bank Guarantee", href: "/services/bank-guarantee" },
      { label: "Export Finance", href: "/services/export-finance" },
    ],
  },
  { label: "Blog", href: "/blog" },
  { label: "Contact Us", href: "/contact" },
];

export const SERVICES = [
  {
    slug: "trade-finance",
    title: "Trade Finance",
    short: "Letter of Credit, Bank Guarantee, SBLC, Export Finance",
    icon: "Landmark",
    description:
      "Comprehensive trade finance solutions to help importers and exporters manage risk and cash flow across international transactions.",
  },
  {
    slug: "project-finance",
    title: "Project Finance",
    short:
      "Financing large infrastructure, hotels, healthcare, education, logistics projects with a mix of debt & equity",
    icon: "Building2",
    description:
      "Structured funding for capital intensive projects with tailored debt and equity mix, backed by rigorous due diligence.",
  },
  {
    slug: "private-equity",
    title: "Private Equity",
    short:
      "Arranging equity for profitable business through investors spread across the globe",
    icon: "TrendingUp",
    description:
      "We connect promising businesses with a global network of investors to accelerate expansion, acquisitions, and growth.",
  },
  {
    slug: "business-advisory",
    title: "Business Advisory",
    short:
      "Consulting before seeking investments or debt for your business can help you navigate smoothly.",
    icon: "Briefcase",
    description:
      "Strategic advisory that prepares your business for capital raising, restructuring, and long-term value creation.",
  },
  {
    slug: "loan-against-property",
    title: "Loan Against Property",
    short:
      "Small & large ticket LAP against plots and apartments \u2013 unlock the value of your real estate",
    icon: "Home",
    description:
      "Flexible loans against residential plots, commercial plots and apartments. Whether you need a small working-capital line or a large ticket facility for expansion, we structure LAP solutions that fit your needs.",
  },
  {
    slug: "loan-against-gold-diamond",
    title: "Loan Against Gold & Diamond",
    short:
      "Unlock instant liquidity against your gold jewellery, gold bars, coins and certified diamonds",
    icon: "Gem",
    description:
      "Secure short-term or long-term financing against your gold and certified diamond assets with transparent valuations, safe custody and competitive rates.",
  },
  {
    slug: "small-scale-financing",
    title: "Small Scale Financing",
    short:
      "Tailored funding for SMEs, startups and small businesses \u2013 working capital, term loans and more",
    icon: "Coins",
    description:
      "Purpose-built financing for small and medium enterprises. From working capital and equipment finance to inventory funding, we help small businesses grow without cash-flow pressure.",
  },
  {
    slug: "large-scale-financing",
    title: "Large Scale Financing",
    short:
      "Structured large ticket financing for corporates, group companies and expansion plans",
    icon: "Factory",
    description:
      "High value financing structures for corporates, holding companies and industrial groups \u2013 including syndicated loans, ECBs, mezzanine debt and structured credit.",
  },
];

export const WHY_US = [
  {
    icon: "GraduationCap",
    title: "Expertise & Knowledge",
    text: "Our consultants bring deep specialised knowledge across trade, debt and equity finance domains.",
  },
  {
    icon: "Scale",
    title: "Objective Advice",
    text: "Unbiased guidance tailored to your business - not products. We work in your best interest.",
  },
  {
    icon: "LineChart",
    title: "Financial Planning",
    text: "Structured financial plans that evaluate current status, identify goals and build a road-map.",
  },
  {
    icon: "Clock",
    title: "Time-Saving",
    text: "We handle complex paperwork, negotiations and compliance so you can focus on running the business.",
  },
];

export const STATS = [
  { value: 10, suffix: "+", label: "Years of Excellence" },
];

export const MARKETS = [
  { country: "United Arab Emirates", code: "UAE", flag: "\ud83c\udde6\ud83c\uddea" },
  { country: "Singapore", code: "SG", flag: "\ud83c\uddf8\ud83c\uddec" },
  { country: "United Kingdom", code: "UK", flag: "\ud83c\uddec\ud83c\udde7" },
  { country: "United States", code: "US", flag: "\ud83c\uddfa\ud83c\uddf8" },
  { country: "South Africa", code: "ZA", flag: "\ud83c\uddff\ud83c\udde6" },
  { country: "Malaysia", code: "MY", flag: "\ud83c\uddf2\ud83c\uddfe" },
  { country: "Ghana", code: "GH", flag: "\ud83c\uddec\ud83c\udded" },
  { country: "India", code: "IN", flag: "\ud83c\uddee\ud83c\uddf3" },
];

export const PROCESS = [
  { step: "01", title: "Discovery", text: "We start by understanding your business, financing needs and long-term objectives." },
  { step: "02", title: "Strategy", text: "Our team designs a tailored financial roadmap with the right instruments and structure." },
  { step: "03", title: "Execution", text: "We negotiate with banks and investors, handle documentation and due diligence." },
  { step: "04", title: "Support", text: "Ongoing relationship management and advisory long after the deal closes." },
];

export const BLOGS = [
  {
    id: 1,
    date: "12 May 2026",
    author: "Aarav Mehta",
    title:
      "How Manufacturers Can Raise Funds Against Factory Premises",
    excerpt:
      "Loan against property (LAP) has become a preferred route for manufacturers seeking working capital and expansion funds.",
    image:
      "https://images.pexels.com/photos/7693201/pexels-photo-7693201.jpeg",
  },
  {
    id: 2,
    date: "03 April 2026",
    author: "Priya Nair",
    title:
      "UAE's Infrastructure Boom: How Mega-Capex is Transforming the Economy",
    excerpt:
      "Record infrastructure spending is reshaping logistics, real-estate and industrial corridors across the GCC.",
    image:
      "https://images.pexels.com/photos/14527417/pexels-photo-14527417.jpeg",
  },
  {
    id: 3,
    date: "09 June 2025",
    author: "Rahul Sharma",
    title:
      "What is Private Equity? Benefits, Structure & How It Works",
    excerpt:
      "A practical guide to how PE funds evaluate deals, structure investments and drive value in portfolio companies.",
    image:
      "https://images.pexels.com/photos/6801680/pexels-photo-6801680.jpeg",
  },
];

export const CLIENT_LOGOS = [
  "Aurora Steel",
  "Meridian Group",
  "BlueOak Capital",
  "Zenith Logistics",
  "Helios Energy",
  "Cobalt Infra",
];

export const TESTIMONIALS = [
  {
    name: "Karan Malhotra",
    role: "Director, Aurora Steel",
    text: "Fortunexis structured a complex LC facility for our raw-material imports in under three weeks. Truly professional.",
  },
  {
    name: "Sara Ibrahim",
    role: "CFO, Helios Energy",
    text: "Their project finance team helped us close a 120 million dirham facility with the right mix of debt and equity.",
  },
  {
    name: "Michael Chen",
    role: "Founder, Zenith Logistics",
    text: "From advisory to closing, the team was hands-on. They understand cross-border trade like few others.",
  },
];

export const TEAM = [
  {
    name: "Yash Rasal",
    role: "Director \u2013 Strategy & Risk",
    prev: "Ex \u2013 Strategic and Risk Assessment Analyst, JP Morgan",
    bio: "Yash brings solid experience in credit risk assessment, portfolio strategy and trade finance. At JP Morgan he worked on risk analysis for cross-border lending and trade finance desks.",
    education: [
      "MBA in Finance",
      "Bachelor's in Commerce",
    ],
    expertise: ["Credit Risk", "Trade Finance", "Portfolio Strategy", "Financial Analysis"],
    image: "/team/yash_rasal.png",
    linkedin: "#",
  },
  {
    name: "Padmaja Verma",
    role: "Director \u2013 International Business & Growth",
    prev: "Ex \u2013 International Sales Head, LSE-listed Global Enterprise",
    bio: "Padmaja has led international sales across EMEA and APAC for a London Stock Exchange listed company. She focuses on cross-border client relationships, key-account strategy and business growth in emerging markets.",
    education: [
      "MBA in International Business",
      "Bachelor's in Commerce",
    ],
    expertise: ["International Sales", "Cross-border Deals", "Client Relationships", "Business Growth"],
    image: "/team/padmaja_verma.png",
    linkedin: "#",
  },
];

export const SERVICE_LIST_FOR_FORM = [
  "Letter of Credit",
  "Standby Letter of Credit \u2013 Without Upfront",
  "Standby Letter of Credit \u2013 With Upfront",
  "Bank Guarantee",
  "Project Funding",
  "Private Equity and Venture Capital",
  "Loan Against Property (Plot / Apartment)",
  "Loan Against Gold & Diamond",
  "Small Scale Financing",
  "Large Scale Financing",
];
